export default "__VITE_ASSET__CgGloDyo__"